import React, { Component } from 'react'
import styles from './styles';
import { css } from 'aphrodite';

class Results extends Component {
  constructor(props) {
    super(props);
  }

  render() {

    const { data } = this.props

    const rendementFR = Math.round(data.fiscaliteRevenusFonciersFrance.tauxRendementNet * 10000) / 100
    const rendementDE = Math.round(data.fiscaliteRevenusFonciersEtranger[0].tauxRendementNet * 10000) / 100

    return (
      <div className={css(styles.responsiveTable)}>
        <table className={css(styles.table)}>
          <tbody>
            <tr>
              <td className={css(styles.tdPadding, styles.redBackgroundLeft, styles.rightSeparatorBig)}>
                Taux marginal d'imposition
              </td>
              <td colSpan="3" className={css(styles.tdPadding, styles.leftBorder, styles.topBorder, styles.rightBorder)}>{data.situationFiscale.tmi} %</td>
            </tr>
            <tr>
              <td className={css(styles.tdPadding, styles.redBackgroundLeft, styles.rightSeparatorBig)}>
                Taux moyen d'imposition situation initiale
              </td>
              <td colSpan="3" className={css(styles.tdPadding, styles.leftBorder, styles.bottomBorder, styles.rightBorder)}>
                {data.situationFiscale.tauxMoyenImposition} %
              </td>
            </tr>

            <tr>
              <td className={css(styles.tdPadding)}></td>
              <td className={css(styles.tdPadding, styles.redBackground, styles.topSeparator, styles.bottomSeparator)}>SCPI 100%  Française</td>
              <td className={css(styles.leftSeparator, styles.rightSeparator)}></td>
              <td className={css(styles.tdPadding, styles.redBackground, styles.topSeparator, styles.bottomSeparator)}>SCPI 100% Allemande</td>
            </tr>


            <tr>
              <td className={css(styles.tdPadding, styles.redBackgroundLeft, styles.rightSeparatorBig)}>Revenus fonciers *</td>
              <td className={css(styles.tdPadding, styles.leftBorder, styles.topBorder, styles.bottomBorder, styles.rightBorder)}>
                {data.revenusFonciers.toLocaleString()} €
              </td>
              <td></td>
              <td className={css(styles.tdPadding, styles.leftBorder, styles.topBorder, styles.bottomBorder, styles.rightBorder)}>
                {data.revenusFonciers.toLocaleString()} €
              </td>
            </tr>

            <tr>
              <td colSpan="4" className={css(styles.tdSpace)}></td>
            </tr>

            <tr>
              <td className={css(styles.tdPadding, styles.redBackgroundLeft, styles.rightSeparatorBig)}>Prélèvements sociaux en vigueur à ce jour**</td>
              <td className={css(styles.tdPadding, styles.topBorder, styles.leftBorder, styles.rightBorder)}>
                {data.fiscaliteRevenusFonciersFrance.prelevementsSociaux[0].montant.toLocaleString()} €
              </td>
              <td></td>
              <td className={css(styles.tdPadding, styles.topBorder, styles.leftBorder, styles.rightBorder)}>
                {data.fiscaliteRevenusFonciersEtranger[0].prelevementsSociaux === null ? '0' : data.fiscaliteRevenusFonciersEtranger[0].prelevementsSociaux.toLocaleString()} €
              </td>
            </tr>

            <tr>
              <td className={css(styles.tdPadding, styles.redBackgroundLeft, styles.rightSeparatorBig)}>Impôts sur revenus fonciers</td>
              <td className={css(styles.tdPadding, styles.leftBorder, styles.rightBorder)}>
                {data.fiscaliteRevenusFonciersFrance.impotRevenus[0].montant.toLocaleString()} €
              </td>
              <td></td>
              <td className={css(styles.tdPadding, styles.rightBorder, styles.leftBorder)}>
                {data.fiscaliteRevenusFonciersEtranger[0].impotRevenus[0].montant.toLocaleString()} €
              </td>
            </tr>

            <tr>
              <td className={css(styles.tdPadding, styles.redBackgroundLeft, styles.rightSeparatorBig)}>Crédits impôts ***</td>
              <td className={css(styles.tdPadding, styles.leftBorder, styles.rightBorder)}>
                {data.fiscaliteRevenusFonciersFrance.creditImpot === null ? '0' : data.fiscaliteRevenusFonciersFrance.creditImpot.toLocaleString()} €
              </td>
              <td></td>
              <td className={css(styles.tdPadding, styles.rightBorder, styles.leftBorder)}>
                {data.fiscaliteRevenusFonciersEtranger[0].creditImpot === null ? '0' : data.fiscaliteRevenusFonciersEtranger[0].creditImpot.toLocaleString()} €
              </td>
            </tr>

            <tr>
              <td className={css(styles.tdPadding, styles.redBackgroundLeft, styles.rightSeparatorBig)}>Total impôts **</td>
              <td className={css(styles.tdPadding, styles.leftBorder, styles.bottomBorder, styles.rightBorder)}>
                {data.fiscaliteRevenusFonciersFrance.totalImpot === null ? '0' : data.fiscaliteRevenusFonciersFrance.totalImpot.toLocaleString()} €
              </td>
              <td></td>
              <td className={css(styles.tdPadding, styles.leftBorder, styles.rightBorder, styles.bottomBorder)}>
                {data.fiscaliteRevenusFonciersEtranger[0].totalImpot === null ? '0' : data.fiscaliteRevenusFonciersEtranger[0].totalImpot.toLocaleString()} €
              </td>
            </tr>

            <tr>
              <td colSpan="3" className={css(styles.tdSpace)}></td>
            </tr>

            <tr>
              <td className={css(styles.tdPadding, styles.redBackgroundLeft, styles.rightSeparatorBig)}>Revenus net</td>
              <td className={css(styles.tdPadding, styles.leftBorder, styles.topBorder, styles.bottomBorder, styles.rightBorder)}>
                {data.fiscaliteRevenusFonciersFrance.revenusfonciersNets === null ? '0' : data.fiscaliteRevenusFonciersFrance.revenusfonciersNets.toLocaleString()} €
              </td>
              <td></td>
              <td className={css(styles.tdPadding, styles.leftBorder, styles.topBorder, styles.bottomBorder, styles.rightBorder)}>
                {data.fiscaliteRevenusFonciersEtranger[0].revenusfonciersNets === null ? '0' : data.fiscaliteRevenusFonciersEtranger[0].revenusfonciersNets.toLocaleString()} €
              </td>
            </tr>

            <tr>
              <td colSpan="3" className={css(styles.tdSpace)}></td>
            </tr>

            <tr>
              <td className={css(styles.tdPadding, styles.redBackgroundLeft, styles.rightSeparatorBig)}>Rendement net</td>
              <td className={css(styles.tdPadding, styles.leftBorder, styles.topBorder, styles.bottomBorder, styles.rightBorder)}>
                {rendementFR} %
              </td>
              <td></td>
              <td className={css(styles.tdPadding, styles.leftBorder, styles.topBorder, styles.bottomBorder, styles.rightBorder)}>
                {rendementDE} %
              </td>
            </tr>

          </tbody>
        </table>
        <div className={css(styles.notesTable)}>
          <span className={css(styles.notestableSpan)}>* Net d'impots allemands à  {data.fiscaliteRevenusFonciersEtranger[0].impotEtranger[0].taux * 100}% sur les revenus locatifs issus des biens immobiliers situés en Allemagne : {data.fiscaliteRevenusFonciersEtranger[0].impotEtranger[0].montant.toLocaleString()} €</span>
          <span className={css(styles.notestableSpan)}>** Taux de prélèvements français  {data.fiscaliteRevenusFonciersFrance.prelevementsSociaux[0].taux}%</span>
          <span className={css(styles.notestableSpan)}>***  Correspond aux revenus locatifs hors de France</span>
        </div>
      </div>
    )
  }
}

export default Results;
